import { findIndex, cloneDeep } from 'lodash';
import turf from '@turf/turf';

import * as templateOps from '../AnnotationTemplates/annotation-template-operations';

/**
 * Searches a certain type of entities in the video whose url is passed and creates an annotation
 * in the database for each entity detected with the structure of the chosen template.
 *
 * @param {string} videoId - The video id.
 * @param {Array} detectedEntity - The data to create the annotation.
 * @param {object} template - The template to be used for the annotations.
 * @param {object[]} featureArray - The array with all the coordinates of the track as feature
 * points.
 * @returns {object} The new annotation.
 * @throws Error if something went wrong.
 */
export const createAIAnnotation = (videoId, detectedEntity, template, featureArray) => {
  const [viewAngle, distance, videoTime, index, resolution, bbox] = detectedEntity;

  let bearing = 0;
  const entityCPIndex = findIndex(featureArray, feature => feature.properties.timeUS >= videoTime);
  if (entityCPIndex < featureArray.length - 1) {
    bearing =
      turf.bearing(featureArray[entityCPIndex], featureArray[entityCPIndex + 1]) + viewAngle;
  } else {
    bearing =
      turf.bearing(featureArray[entityCPIndex], featureArray[entityCPIndex - 1]) + viewAngle;
  }

  const templateToInsert = cloneDeep(template);
  templateToInsert.name = `${templateOps.getName(templateToInsert)} - ${index}`;

  const options = {
    units: 'kilometers',
    properties: {
      video: videoId,
      videoTime,
      videoPosition: {
        x: (bbox[0] + bbox[2]) / 2,
        y: (bbox[1] + bbox[3]) / 2,
        width: resolution[0],
        height: resolution[1]
      },
      template: templateToInsert
    }
  };

  const annotation = {
    geoJSON: turf.destination(featureArray[entityCPIndex], distance / 1000, bearing, options),
    origin: 'automatic'
  };

  return annotation;
};

export default {
  createAIAnnotation
};
